import { Component } from "@angular/core";

@Component({
  selector: "app-claim",
  template: "<router-outlet></router-outlet>",
})
export class ClaimComponent {}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/claim/claim.component.ts